module.exports = {
  type: {
    host: "HOST",
    ephemeral: "EPHEMERAL",
    unknown: "UNKNOWN"
  },
  mode: {
    rw: "RW",
    ro: "RO"
  }
};



// WEBPACK FOOTER //
// ./plugins/services/src/js/constants/VolumeConstants.js